import React, { useContext, useEffect } from "react";
import { Menu, Icon, Dropdown, Popup, Image } from "semantic-ui-react";
import { Link, useNavigate } from "react-router-dom";
import ChangePasswordForm from "../user/ChangePasswordForm";
import EditUserForm from "../user/EditUserForm";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../app/stores/rootStore";

const NavBar = () => {
  const navigate = useNavigate();

  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { user, logout } = rootStore.userStore;
  const { openModal } = rootStore.modalStore;
  const { getBroker, broker, image } = rootStore.companyStore;

  useEffect(() => {
    getBroker();
  }, [getBroker]);

  //variable para el uso del enrutamiento de react-router-dom
  let match = {
    url: '/home'
  };

  return (
    <div>
      <Menu stackable>
        {image != null && (
          <Menu.Item fitted>
            <div className="logo">
              <Link to={`${match.url}/Client/DashboardClient`}>
                <Popup
                  basic
                  content={<Image src={image} />}
                  trigger={<Image src={image} />}
                />
              </Link>
            </div>
          </Menu.Item>
        )}
        <Menu.Item
          onClick={() => navigate(`${match.url}/Client/DashboardClient`)}
          name="nombreEmpresa"
          className="supplierName"
        >
          {broker?.name || broker?.registrationName || "MajimDev"}
        </Menu.Item>

        <Menu.Menu position="right">
          <Menu.Item name="iconos">
            <Link to={`${match.url}/Client/DashboardClient`}>
              <Popup
                basic
                content="Clientes"
                trigger={<Icon size="large" color="black" name="users" />}
              />
            </Link>
            <Link to={`${match.url}/Report`}>
              <Popup
                basic
                content="Reportes"
                trigger={<Icon size="large" color="black" name="area graph" />}
              />
            </Link>
            <Link to={`${match.url}/Configuration`}>
              <Popup
                basic
                content="Configuración"
                trigger={<Icon size="large" color="black" name="sun outline" />}
              />
            </Link>
          </Menu.Item>
          <Menu.Item name="user">
            <Dropdown floating basic text={user?.username}>
              <Dropdown.Menu>
                <Dropdown.Item as="h3" disabled>
                  <strong>
                    {user?.name} {user?.lastName}
                  </strong>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item
                  onClick={() =>
                    openModal(<EditUserForm />, "Editando mi perfil")
                  }
                >
                  Edita tu perfil
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() =>
                    openModal(<ChangePasswordForm />, "Cambia tu contraseña")
                  }
                >
                  Cambia tu contraseña
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item>
                  <Link to={`${match.url}`}>Politica de Privacidad</Link>
                </Dropdown.Item>
                <Dropdown.Item onClick={logout}>Cerrar sesión</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
        </Menu.Menu>
      </Menu>
    </div>
  );
};
export default observer(NavBar);
